<template>
  <div class="bread treemap">
    <div class="floor" v-for="(list, index) in treeData" :key="index">
      <div class="title">
        <span class="number">{{ list.label }}</span>
        <span class="area">{{ list.total }}</span>
      </div>
      <div class="flex-box">
        <div class="block" :style="getWidth(list, index, indexSub)" v-for="(item, indexSub) in list.children || []" :key="'l' + indexSub">
          <div class="inner" :style="getBack(item)" :data-msg="getItem(item)" @mouseover="showDetail" @mouseout="closeDetail">
            <div class="text" v-for="(value, key, indexSub1) in item" :key="indexSub1" :style="getText(key)">
              <p :style="getTextBack(key, value)">{{ value }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tm_detail" v-show="detailView">
      <div class="d-item" v-for="(value,key,index) in detailData" :key="'i'+index">
        <span>{{key}}</span>
        :
        <span>{{value}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getLabelColor } from '@/api/instrumentControl'
export default {
  name: 'treeMap',
  props: {
    h: Number,
    //- 分组字段数据
    row: {
      type: Array,
      default: ()=>[]
    },
    //- 汇总字段数据
    summary: {
      type: Array,
      default: ()=>[]
    },
    //- drage组件大小修改后，饼图实时更新
    changeSize: {
      type: Number,
      default: 0
    },
    //- 表格数据
    tableData: {
      type: Array,
      default: ()=>[]
    },
    //- 表id
    id: {
      type: Number,
      default: 0
    },
    //- isFrontEnd是否为前端或者后端展示:true为后端,false为前端
    isFrontEnd: {
      type: Boolean,
      default: ()=>false
    },
    viewShow: {
      type: Boolean,
      default: ()=>false
    },
    selectIndex: {
      type: Number,
      default: ()=>null
    },
    user: {
      type: Array,
      default: () => []
    },
    width: [String, Number],
    isMobile: {
      type: Boolean,
      default: false
    },
    theme: Object,
    column: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: function () {
    return {
      treeData: [], //矩形树图数据
      rowVal: '', //行字段
      summaryVal: '', //汇总面积默认用汇总字段中的第一个字段
      copyData: [], // 汇总计算（用户可能设置汇总字段中的第一个字段不显示）
      detailData:{}, // 详情数据
      detailView:false,
    }
  },
  mounted() {
    this.showField(this.tableData)
  },
  methods: {
    // 筛选显示字段
    showField(val){
      this.copyData = JSON.parse(JSON.stringify(val)) // 汇总计算（用户可能设置汇总字段中的第一个字段不显示）
      const displayConfig = this.config.blockDisplay //块显示配置
      this.rowVal = this.row[0].revisabilityName || this.row[0].name //行字段
      this.summaryVal = this.summary[0].name || this.summary[0].revisabilityName //汇总面积默认用汇总字段中的第一个字段
      //未设置块显示
      if (typeof(displayConfig) == 'undefined' || Object.keys(displayConfig).length === 0) {        
        for(let i = 0; i < val.length; i++){
          val[i].total = 0
          for(let j = 0; j < val[i].children.length; j++){
            // 计算行左侧显示的汇总字段值
            val[i].total = Number(val[i].total) + Number(this.copyData[i].children[j][this.summaryVal])
            console.log("汇总字段的第一个字段:",val[i].total);
            if(isNaN(val[i].total)){
              this.$message.error('汇总字段的第一个字段必须是数字类型！')
              return false
            }
            // 筛选删除行数据
            if(val[i].children[j][this.rowVal]){
              delete val[i].children[j][this.rowVal]
            }
          }
        }
        this.treeData = val
      }
      else{
        let showFieldVal = [] // 当前设置显示的字段
        let allFieldVal = [] // 列、汇总字段所有字段
        for(let i = 0; i < displayConfig.length; i++){
          showFieldVal.push(displayConfig[i].label)
        }
        for(let i = 0; i < this.column.length; i++){
          allFieldVal.push(this.column[i].name || this.column[i].revisabilityName)
        }
        for(let i = 0; i < this.summary.length; i++){
          allFieldVal.push(this.summary[i].name || this.summary[i].revisabilityName)
        }
        let diffField = this.getArrDifference(showFieldVal, allFieldVal) // 已设置隐藏的字段
        for(let i = 0; i < val.length; i++){
          val[i].total = 0
          for(let j = 0; j < val[i].children.length; j++){
            // 计算行左侧显示的汇总字段值
            val[i].total = Number(val[i].total) + Number(this.copyData[i].children[j][this.summaryVal])
            console.log("汇总字段的第一个字段:",val[i].total);
            if(isNaN(val[i].total)){
              this.$message.error('汇总字段的第一个字段必须是数字类型！')
              return false
            }
            // 筛选删除行数据
            if(val[i].children[j][this.rowVal]){
              delete val[i].children[j][this.rowVal]
            }
            // 筛选删除列、汇总字段未设置显示的数据
            for(let k = 0; k < diffField.length; k++){
              if(val[i].children[j][diffField[k]]){
                delete val[i].children[j][diffField[k]]
              }
            }
            
          }
        }
        this.treeData = val
      }
    },    
    // 块颜色背景
    getBack (values) {
      if (this.config.blockColor && this.config.blockColor.isColor) {
        const key = this.config.blockColor.size.format ? this.config.blockColor.size.name : (this.config.blockColor.size.revisabilityName || this.config.blockColor.size.name)
        const color = getLabelColor({options: this.config.blockColor.colorConfig}, values[key], true)
        if (color.backgroundColor) {
          return { backgroundColor: color.backgroundColor }
        }
      }
      return {}
    },
    // 块宽度
    getWidth(list, index, indexSub){
      const _width = this.copyData[index].children[indexSub][this.summaryVal] / list.total * 100
      return { width:_width.toFixed(2) + '%' }
    },
    // 块显示
    getText(key){
      const displayConfig = this.config.blockDisplay
      if (typeof(displayConfig) != 'undefined' && displayConfig.length > 0) {
        let styleInfo = displayConfig.filter(item => item.label == key)
        let obj = {}      
        if (styleInfo.length > 0) {
          obj = styleInfo[0].columnFont
          obj.width = styleInfo[0].w + 'px'
          obj.height = styleInfo[0].h + 'px'
          obj.left = styleInfo[0].leftPercent ? styleInfo[0].leftPercent + '%' : styleInfo[0].x + 'px'
          obj.top = styleInfo[0].y + 'px'
          obj.display = 'block'
        }
        return obj
      }
      else {
        return { display: 'block' }
      }
    },
    // 匹配字段背景色
    getTextBack(key, value){
      const displayConfig = this.config.blockDisplay
      if (typeof(displayConfig) != 'undefined' && displayConfig.length > 0) {
        let styleInfo = displayConfig.filter(item => item.label == key)
        if (styleInfo.length > 0) {
          const color = getLabelColor({options: styleInfo[0].columnFont.colorTag.colorConfig}, value, true)
          if (color.backgroundColor) {
            return { backgroundColor: color.backgroundColor }
          }
        }
      }
      return {}
    },
    // 字段选择前后差异对比
    getArrDifference(arr1, arr2){
      return arr1.concat(arr2).filter(function(value, i, arr){
        return arr.indexOf(value) === arr.lastIndexOf(value);
      })
    },
    showDetail(event){
      var _event = event || window.event
      if(_event.target.className !== 'inner'){
        _event.stopPropagation();
        _event.cancelBubble = true
        return false
      }
      this.detailView = true
      this.detailData = JSON.parse(_event.target.dataset.msg)
      document.addEventListener('mousemove',this.detailMove)
    },
    closeDetail(event){
      var _event = event || window.event
      if(_event.target.className !== 'inner'){
        _event.stopPropagation();
        _event.cancelBubble = true
        return false
      }
      this.detailView = false
      this.detailData = {}
      document.removeEventListener('mousemove',this.detailMove)
    },
    detailMove(e){
      const detail = document.querySelector('.tm_detail')
      document.body.appendChild(detail)
      var y = e.y
      var x = e.x
      if( x + 232 > document.body.offsetWidth - 50 ){
          x = x - 232
      }
      detail.style.left = x + 'px'
      detail.style.top = y + 'px'
    },
    getItem(item){
      return JSON.stringify(item)
    },
    // 对比数组对象是否完全一致
    isEqual(a, b) {
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length !== b.length) return false;

      for (var i = 0; i < a.length; ++i) {
        if (Array.isArray(a[i]) && Array.isArray(b[i])) {
          if (!this.isEqual(a[i], b[i])) return false;
        } else if (a[i] !== b[i]) {
          return false;
        }
      }
      return true;
    }
  },
  watch: {
    changeSize(val) {
      console.log("w===>",val)
      if(this.tableData.length>0){
        setTimeout(() => {
          this.updateFun();

        }, 1000);

      }

    },
    'tableData':{
      handler (newV, oldV) {
        // do something, 可使用this
        console.log("newV===",newV)
        console.log("oldV===",oldV)
        const isEqual = this.isEqual(newV, oldV);
        if(newV && newV.length>0 && !isEqual){
          this.$nextTick(()=>{
            console.log("数据更新了");
            this.showField(newV)
          })
        }

      },
      deep:true

    },
    'selectIndex': {
      handler(newName) {

        console.log("变话了",newName)
        
      },
      deep:true
    },
    viewShow: {
      immediate: true,
      handler () {
        
      }
    },
    width: {
      immediate: true,
      handler () {
        
      }
    },
    theme: {
      immediate: true,
      deep: true,
      handler () {
        console.log('配置更新')
        
      }
    },
  }
}
</script>

<style scoped lang="scss">
.bread {
  width: 100%;
  height: 100%;
  position: relative;
  .floor {
    position: relative;
    padding-left: 78px;
    .title {
      position: absolute;
      left: 0;
      top: 4px;
      width: 74px;
      height: 76px;
      padding: 16px 6px 0 12px;
      box-sizing: border-box;
      border-radius: 4px;
      background-color: #F5F5F5;
      span {
        display: block;
        margin-bottom: 9px;
        height: 18px;
        line-height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:first-child {
          color: #333;
        }
        &:last-child {
          color: #666;
        }
      }
    }
    .flex-box {
      width: 100%;
      display: flex;
      justify-content:space-around;
      .block {
        padding: 4px;
        box-sizing: border-box;     
        &:last-child {
          padding-right: 0;
        }
        .inner {
          position: relative;
          height: 76px;
          box-sizing: border-box;
          background-color: #B3DBFA;
          border-radius: 4px;
          overflow: hidden;
          .text {
            position: absolute;
            left: 10px;
            top: 10px;
            display:none;
            height: 18px;
            line-height: 18px;
            color: #666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            border-radius: 2px;
            p {
              height: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            &:nth-child(1) {
              color: #333;
            }
            &:nth-child(2) {
              top: 28px;
            }
            &:nth-child(3) {
              top: 46px;
            }
            &:nth-child(4) {
              color: #333;
              left: 50%;
              top: 10px;
            }
            &:nth-child(5) {
              left: 50%;
              top: 28px;
            }
            &:nth-child(6) {
              left: 50%;
              top: 46px;
            }
          }
        }
        .inner *{
          pointer-events: none;
        }
      }
    }
  }
}
.treemap {
  overflow: auto;
  padding: 0 20px;
  box-sizing: border-box;
}
.tm_detail{
  position: absolute;
  top: 0;
  left: 0;
  width: 232px;
  padding: 15px 20px;
  border-radius: 4px;
  background-color: #FFFFFF;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.3);
  pointer-events: none;
  transition: all 0.3s;
  z-index:2023;
  .d-item{
    font-family: PingFangSC;
    color: #333333;
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 6px;
  }
  .d-item:last-child{
    margin-bottom: 0px
  }
}
.nodata {
  width: 100%;
  text-align: center;
  color: #666666;
  //line-height: 244px;
  height: 100%;
  position: relative;
  span{
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    margin-left: -29px;
  }
}
</style>
